"use strict";

exports.__esModule = true;
exports.ElementColorControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _core = require("@blueprintjs/core");
var _ColorPicker = require("../../../Form/ColorPicker");
var _class, _ElementColorControlGroup;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Controls for changing color and backgroundColor properties of an element.
 */
var ElementColorControlGroup = exports.ElementColorControlGroup = (0, _styledComponents.withTheme)(_class = (_ElementColorControlGroup = /*#__PURE__*/function (_Component) {
  function ElementColorControlGroup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementColorControlGroup, _Component);
  var _proto = ElementColorControlGroup.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      elementEditor = _this$props.elementEditor,
      controlPaths = _this$props.controlPaths,
      theme = _this$props.theme;
    var color = controlPaths.color,
      backgroundColor = controlPaths.backgroundColor;
    return /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      large: true,
      minimal: true
    }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
      value: elementEditor.getProp(color, "color", theme.color),
      onChange: function onChange(value) {
        return color !== undefined && elementEditor.setProp(color, "color", value);
      },
      disabled: !color
    }), /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
      value: elementEditor.getProp(backgroundColor, "backgroundColor", theme.background),
      onChange: function onChange(value) {
        return backgroundColor !== undefined && elementEditor.setProp(backgroundColor, "backgroundColor", value);
      },
      disabled: !backgroundColor
    }));
  };
  return ElementColorControlGroup;
}(_react.Component), _ElementColorControlGroup.defaultProps = {
  theme: undefined
}, _ElementColorControlGroup)) || _class;